import { useMemo } from "react"
import { useLocation } from "react-router-dom"
import { RoutePath } from "routers/config"
import { EUserRole, EVendorType } from "types"
import { useMe } from "utils/api/user"
import { useSettingDetail } from "utils/api/vendor-setting"

export default function useProfile() {
  const location = useLocation()
  const { user, isLoading } = useMe()
  const isVendorSuperAdmin = useMemo(
    () => user?.role === EUserRole.Vendor_Super_Admin,
    [user]
  )
  const isVendorAdmin = useMemo(
    () => user?.role === EUserRole.Vendor_Admin,
    [user]
  )
  const isAdmin = useMemo(
    () => user?.role === EUserRole.Pom_Super_Admin,
    [user]
  )
  const isImpersonating = useMemo(() => Boolean(user?.impersonated), [user])
  const isVendorBrandStore = useMemo(
    () => user?.vendor?.vendor_type === EVendorType.BrandStore,
    [user]
  )

  const isVendor = useMemo(
    () => isVendorSuperAdmin || isVendorAdmin,
    [isVendorSuperAdmin, isVendorAdmin]
  )

  const ísEvent = useMemo(
    () => location.pathname.split("/")[1] === RoutePath.Events.split("/")[1],
    [location]
  )

  const vendorId = user?.vendor?.id || user?.vendor_id
  const { data: vendorSetting } = useSettingDetail({
    vendorId: isVendorBrandStore ? vendorId : undefined,
  })

  return {
    user,
    role: user?.role as EUserRole,
    vendorName: user?.vendor?.name,
    isVendorBrandStore,
    isVendorAdmin,
    isVendor,
    isVendorSuperAdmin,
    isAdmin,
    isImpersonating,
    isLoading,
    ísEvent,
    vendor_id: vendorId,
    isShowChat: vendorSetting?.is_show_chat ?? false,
  }
}
